import Vue from 'vue'
import VueTippy from 'vue-tippy/src/index'
import '@/assets/less/tippy-theme.less'

Vue.use(VueTippy, {
  arrow: true,
  theme: 'jiminny'
})



// WEBPACK FOOTER //
// ./src/plugins/vue-tippy.js